

<template>
  <div class="preview-part-drawing">
    <el-dialog
      :title="previewData.originalName"
      width="800px"
      :visible.sync="previewPictureDialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <div class="preview-part-drawing-img">
        <!-- v-if="previewData.attachFormat === 10" -->
        <el-image
          fit="scale-down"
          :src="`${pictureUrl}${isWm ? '?wm=1' : ''}`"
        >
          <div slot="placeholder" class="image-slot el-icon-loading">
            <!-- <img src="@/assets/img/oss/noimg.png" alt /> -->
          </div>
        </el-image>
        <!-- <iframe
          style="width: 100%; height: 535px"
          :src="`${serverCommon}/static/stl/stl.html?stl=${serverCommon}/oss/parts-library/detail/3d-preview/${previewData.hashCode}&wm=1`"
          v-if="previewData.attachFormat === 20"
          frameborder="0"
        ></iframe> -->
      </div>
    </el-dialog>
  </div>
</template>

<script >
// import urls from '@/utils/baseUrl'
import { onlineUrl } from '@/utils/config.js'
export default {
  props: {
    previewPictureDialogVisible: {
      default: false,
      type: Boolean,
    },
    previewData:{
      default: {},
      type: Object,
    },
    pictureUrl:{
      default:'',
      type:String
    },
    isWm:{
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      // serverCommon:urls.baseUrl,
      // serverHost:urls.oss_url,
      onlineUrl:onlineUrl,
    }
  },
  methods: {
    handleClose(){
      this.$emit("closePreviewPicture");
    }
  },
  mounted() {
  },
}
</script>

<style lang="scss">
.preview-part-drawing {
  .preview-part-drawing-img {
    display: flex;
    align-items: center;
    justify-content: center;
    // padding:20px;
    .el-image {
      width: 600px;
      height: 500px;
      text-align: center;
      .image-slot {
        position: absolute;
        width: max-content;
        height: max-content;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        font-size: 30px;
      }
    }
  }
}
</style>
